export default __webpack_public_path__ + "static/media/epl-banner.bb3a35bd.jpg";